// API status codes: 0=Completed, 1=Queued, 4=Processing, 20=Errored, 21=Cancelled.
const OrderStatuses = {
    0: { displayedName: 'Completed' },
    1: { displayedName: 'Queued' },
    4: { displayedName: 'Processing' },
    20: { displayedName: 'Errored' },
    21: { displayedName: 'Cancelled' },
};

export default OrderStatuses;
